<template>
    <p>
        {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        <br />
        {{ userStore.user.address }}
        <br />
        {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
    </p>
    <p>
        {{ date }}
    </p>
    <p>
        {{ creditBureau.address_name }}
        <br />
        {{ address.street }}
        <br />
        {{ address.city }}, {{ address.state_abbreviation }} {{ address.zipcode }}
    </p>
    <p>
        To whom it may concern,
    </p>
    <p class="letter-content">
        I recently received a copy of my {{ creditBureau.address_name }} consumer report, and I noticed some late payments posted on my consumer report:
    </p>
    <p v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id)">
        <strong>
            {{ creditor.furnisher_name }} with account number 
            <template v-if="creditor.reference_number">
                {{ creditor.reference_number }}
            </template>
            <template v-else>
                {{ creditor.account_number }}
            </template>
        </strong>
        <template v-if="creditor.reason">
            <br />
            {{ creditor.reason }}
        </template>
    </p>
    <p class="letter-content">
        Your company is in clear violation of the law. Under 15 USC §1681b - permissible purpose of consumer reports, THE LAW CLEARLY STATES:
    </p>
    <p class="letter-content">
        &emsp;(a) IN GENERAL
    </p>
    <p class="letter-content">
        &emsp;Subject to subsection (c) any consumer reporting agency may furnish a consumer report under the following circumstances and no other:
    </p>
    <p class="letter-content">
        &emsp;&emsp;(2) In accordance with the written instructions of the consumer to whom it relates.
    </p>
    <p class="letter-content">
        Did I give you written instructions to furnish this account on my credit report?
    </p>
    <p class="letter-content">
        Furthermore, the FAIR CREDIT REPORTING ACT 15 USC §1681a(2)(a)(i) Exclusions from a consumer credit report clearly states:
    </p>
    <p class="letter-content">
        &emsp;(2) EXCLUSIONS.—Except as provided in paragraph (3), the term “consumer report” does not include—
    </p>
    <p class="letter-content">
        &emsp;&emsp;(A) Subject to section 1681s-3 of this title, any—
    </p>
    <p class="letter-content">
        &emsp;&emsp;&emsp;(i) report containing information solely as to transactions or experiences between the consumer and the person making the report;
    </p>
    <p class="letter-content">
        Delete the above late payments from my consumer report, this agency is in violation of 15 USC §1681.
    </p>
    <p class="letter-content">
        Failure to respond satisfactorily with deletion of the above referenced account, and send out a free copy of my report after the changes have been made will result in legal actions being taken against your company, for which I will also be seeking $ 1,000 per violation for:
    </p>
    <ol>
        <li>
            Defamation of Character (per se)
        </li>
        <li>
            Negligent Enablement of Identity Fraud
        </li>
        <li>
            Fair Debt Collections Practices Act 15 USC §1692g violations 
        </li>
        <li>
            Fair Credit Reporting Act 15USC §1681 violations for willful noncompliance - §616. Civil liability for willful noncompliance [15 U.S.C. §1681n] 
        </li>
    </ol>
    <p>
        Best regards,
        <br />
        {{ userStore.user.firstname }} {{ userStore.user.lastname }}
    </p>
    <div class="page-content">
        <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
        <p style="padding-top:3rem; text-align: center;">
            <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
            <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
        </p>
        <p v-if='userStore.user.address_verify_image_url'>
            <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            }
        },
        setup(props) {
            const address = _.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore(),
                _: _,
                address,
            };
        }
    };
</script>
